/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageUsersByTargetSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageUsersByTargetSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageUsersByTargetSecurity = {
  option1?: GetToolUsageUsersByTargetSecurityOption1 | undefined;
  option2?: GetToolUsageUsersByTargetSecurityOption2 | undefined;
};

export type GetToolUsageUsersByTargetRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageUsersByTargetSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageUsersByTargetSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetToolUsageUsersByTargetSecurityOption1$Outbound,
    GetToolUsageUsersByTargetSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getToolUsageUsersByTargetSecurityOption1ToJSON(
  getToolUsageUsersByTargetSecurityOption1:
    GetToolUsageUsersByTargetSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageUsersByTargetSecurityOption1$outboundSchema.parse(
      getToolUsageUsersByTargetSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageUsersByTargetSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageUsersByTargetSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetToolUsageUsersByTargetSecurityOption2$Outbound,
    GetToolUsageUsersByTargetSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getToolUsageUsersByTargetSecurityOption2ToJSON(
  getToolUsageUsersByTargetSecurityOption2:
    GetToolUsageUsersByTargetSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageUsersByTargetSecurityOption2$outboundSchema.parse(
      getToolUsageUsersByTargetSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageUsersByTargetSecurity$Outbound = {
  Option1?: GetToolUsageUsersByTargetSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageUsersByTargetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageUsersByTargetSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageUsersByTargetSecurity$Outbound,
  GetToolUsageUsersByTargetSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageUsersByTargetSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageUsersByTargetSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageUsersByTargetSecurityToJSON(
  getToolUsageUsersByTargetSecurity: GetToolUsageUsersByTargetSecurity,
): string {
  return JSON.stringify(
    GetToolUsageUsersByTargetSecurity$outboundSchema.parse(
      getToolUsageUsersByTargetSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageUsersByTargetRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageUsersByTargetRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageUsersByTargetRequest$Outbound,
  GetToolUsageUsersByTargetRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageUsersByTargetRequestToJSON(
  getToolUsageUsersByTargetRequest: GetToolUsageUsersByTargetRequest,
): string {
  return JSON.stringify(
    GetToolUsageUsersByTargetRequest$outboundSchema.parse(
      getToolUsageUsersByTargetRequest,
    ),
  );
}
